import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if @modal._isOpen}}\n  <Hds::Modal @onClose={{@modal.close}} @size={{@size}} @color={{@color}} @isDismissDisabled={{@modal.isDismissDisabled}} ...attributes as |M|>\n    {{yield M}}\n  </Hds::Modal>\n{{/if}}", {
  moduleName: "vagrant/components/modal/index.hbs"
});